import React, { useRef, useEffect, useState, createRef } from "react";
import { Link } from "react-router-dom";
import PercentageBar from '../PercentageBar';
import "../../Styles/HomeMap.css";
import { AiFillCaretUp, AiFillCaretRight, AiFillCaretLeft } from "react-icons/ai";
import { useScreenshot, createFileName } from "use-react-screenshot";
import Sidebar from "../Sidebar";
import Chart from "./Chart";
import mapboxgl from 'mapbox-gl';
import html2canvas from "html2canvas";
import { world_religion } from "./WorldReligion";
import { SideController } from "./SideController";
import Scale1 from '../../Assets/stripe1.jpg';
import Scale2 from '../../Assets/stripe2.jpg';
import Scale3 from '../../Assets/stripe2.jpg';
import { Centroid } from "../../Centroid";
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import {religious_data} from "../../Religious_data";

mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtYW4iLCJhIjoiY2syNWs1ajk3MGM2NjNua3gxYTNhdWpkOSJ9.ngu-SlVjhLdLBPyDFFsIBw';

const HomeMap = () => {
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-70.9);
    const [lat, setLat] = useState(42.35);
    const [zoom, setZoom] = useState(1);
    const [buddhism_hover, setBuddhism_hover] = useState(false);
    const [east_hover, setEast_hover] = useState(false);
    const [hinduism_hover, setHinduism_hover] = useState(false);
    const [islam_hover, setIslam_hover] = useState(false);
    const [christianity_hover, setChristianity_hover] = useState(false);
    const [other_hover, setOther_hover] = useState(false);
    const [sideOpen, setSideOpen] = useState(true);
    const [firstReligion, setFirstReligion] = useState("...");
    const [secondReligion, setSecondReligion] = useState("...");
    const [province, setProvince] = useState("...");
    const [country, setCountry] = useState("...");
    const [numerical, setNumerical] = useState(null);
    const [year, setYear] = useState("...");
    const [dataSource, setDataSource] = useState("...");
    const [dataURL, setDataURL] = useState("...");
    const [sideMode, setSideMode] = useState("default");
    // const [display, setDisplay] = useState("map");
    // const buddhismSubs= ["Tibetan","Theravada","Mahayana"];
    // let hoveredStateId = null;
    const [z, setZ] = useState(1);
    

    useEffect(() => {
        //if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [lng, lat],
            zoom: zoom,
            maxZoom: 5,
            renderWorldCopies: false,
        });
        map.current.addControl(new mapboxgl.NavigationControl());
        map.current.addControl(
          new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            marker:false,
            types:"country,region",
            collapsed: true,
            placeholder:"Country, province"
            })
          );
          map.current.doubleClickZoom.disable();map.current.doubleClickZoom.disable();
    }, []);

    useEffect(() => {
        map.current.on('load', () => {
            map.current.addSource('world_religion', {
                'type': 'vector',
                'url': 'mapbox://edman.BRI_Religion_JSON2'
            });
            map.current.addLayer(world_religion, 'state-label');
            map.current.addLayer({
                'id': 'state-fills',
                'type': 'fill',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'fill-color': 'transparent','fill-outline-color':'black','fill-opacity': ['case',['boolean', ['feature-state', 'click'], false],1,0]}
                }
            );
            map.current.addLayer({
                'id': 'hover-fills',
                'type': 'line',
                'source': 'world_religion',
                'source-layer': 'BRI_Religion_JSON2',
                'layout': {},
                'paint': {'line-width': 1}
                },'state-label'
            );
            map.current.setFilter("hover-fills", false);
            // console.log(map.current.getStyle().layers)
            //map.current.setLayoutProperty("settlement-label", 'visibility', 'none');
        });
        map.current.on('mouseenter', (e) => {
          map.current.getCanvas().style.cursor = 'crosshair';
        });
        map.current.on('mousemove', 'world_religion', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            // const popup = new mapboxgl.Popup({
            //   closeButton: false,
            //   closeOnClick: false
            //   });
            // var a = Centroid.find(item=>item.ProvName==e.features[0].properties.ProvName);
            // const coordinates = [a.X, a.Y];
            // const description = e.features[0].properties.ProvName;
            // popup.setLngLat(coordinates).setHTML(description).addTo(map.current);
            
        });
        map.current.on('click', 'hover-fills', (e) => {
            map.current.setFilter("hover-fills", [
                "any",
                ["==", "ProvName", e.features[0].properties.ProvName],
              ]);
            setFirstReligion(e.features[0].properties.HighRelig);
            setSecondReligion(e.features[0].properties.SecRelig);
            setProvince(e.features[0].properties.ProvName);
            setCountry(e.features[0].properties.Country);
            setNumerical(e.features[0].properties.Numerical);
            setYear(e.features[0].properties.Year);
            setDataSource(e.features[0].properties.DataSource);
            setDataURL(e.features[0].properties.DataURL);
            
        });

        map.current.on('mouseleave', 'state-fills', () => {
            map.current.setFilter("hover-fills", false);
            popup.remove();}
        );

        map.current.on('dblclick', 'state-fills', (e) => {
          save(e.features[0].properties.Country ,e.features[0].properties.ProvName);
        });

        map.current.on('zoom', () => {
          var zlevel = parseInt(map.current.getZoom());
          document.getElementById('zoomextent').innerHTML=zlevel;
          setZ(zlevel);
          });

        map.current.on('rotate', function () {
          document.getElementById('rotationslidercurrent').innerHTML='Rotate: ' + map.current.getBearing().toFixed(1) + '&#xb0;'
          document.getElementById('rotationslider').style.display = 'unset';
          document.getElementById('rotationsliderinput').value=map.current.getBearing().toFixed(1);
        });

        map.current.on('pitch', function () {
          document.getElementById('tiltslidercurrent').innerHTML='Tilt: ' + map.current.getPitch().toFixed(1) + '&#xb0;'
          document.getElementById('tiltslider').style.display = 'unset';
          //document.getElementById('rotationsliderinput').getAttribute("value").value(map.current.getBearing().toFixed(1))
        });
        map.current.on('load', () => {
          map.current.setFilter("world_religion", f);
          SideController(map);
          document.getElementById("rotationRE").onclick= resetRfun;
          document.getElementById("tiltRE").onclick= resetTfun;
          document.getElementById("rotationsliderinput").oninput= barRotate;
          document.getElementById("tiltsliderinput").oninput= barTilt;
          document.getElementsByClassName('mapboxgl-ctrl-zoom-in')[0].title="Zoom in";
          document.getElementsByClassName('mapboxgl-ctrl-zoom-out')[0].title="Zoom out";
          document.getElementsByClassName('mapboxgl-ctrl-compass')[0].title="Reset bearing to north";
          document.getElementsByClassName("save")[0].onclick = function(){
            setSideMode("save")
          }
          
        });
        
    }, []);

    const [f,setF] = useState([
      "any",
      ["==", "HighRelig", "Buddhists(Tibetan Buddhism)"],
      ["==", "HighRelig", "Buddhists(Theravada)"],
      ["==", "HighRelig", "Buddhists(Mahayana)"],
      ["==", "HighRelig", "East Asian Religiosity"],
      ["==", "HighRelig", "Hindus"],
      ["==", "HighRelig", "Muslims(Sunni)"],
      ["==", "HighRelig", "Muslims(Shia)"],
      ["==", "HighRelig", "Muslims(Non-denominational)"],
      ["==", "HighRelig", "Muslims(Ibadi)"],
      ["==", "HighRelig", "Protestants"],
      ["==", "HighRelig", "Eastern orthodox"],
      ["==", "HighRelig", "Catholics"],
      ["==", "HighRelig", "Oriental orthodox"],
      ["==", "HighRelig", "Mormons"],
      ["==", "HighRelig", "Ethnic and other religionists"],
      ["==", "HighRelig", "No Data"]
    ]);

    const [tibetanOn,setTibetanOn] = useState(true);
    const [theravadaOn,setTheravadaOn] = useState(true);
    const [mahayanaOn,setMahayanaOn] = useState(true);
    const [eastOn,setEastOn] = useState(true);
    const [hinduOn,setHinduOn] = useState(true);
    const [sunniOn,setSunniOn] = useState(true);
    const [shiaOn,setShiaOn] = useState(true);
    const [nonOn,setNonOn] = useState(true);
    const [ibadiOn,setIbadiOn] = useState(true);
    const [protestantsOn,setProtestantsOn] = useState(true);
    const [orthodoxOn,setOrthodoxOn] = useState(true);
    const [catholicsOn,setCatholicsOn] = useState(true);
    const [orientalOn,setOrientalOn] = useState(true);
    const [mormonOn,setMormonOn] = useState(true);
    const [otherOn,setOtherOn] = useState(true);
    const [buddhismOn,setBuddhismOn] = useState(true);
    const [islamOn,setIslamOn] = useState(true);
    const [christianityOn,setChristianityOn] = useState(true);
    const [saved, setSaved] = useState([]);
    const [markers, setMarkers] = useState({});
    
    function save(country, province){
      var a = religious_data.find(e=>(e.ProvName==province && e.Country==country));
      var s = saved;
      if (!s.includes(a)){
        s.push(a);
        var a = Centroid.find(item=>item.ProvName==province);console.log([a.X,a.Y]);
          const marker = new mapboxgl.Marker();
          marker.setLngLat([a.X,a.Y]).addTo(map.current);
          markers[province] = marker;
      }
      else{
        var index = s.indexOf(a);
        if (index !== -1) {s.splice(index, 1);}
        console.log(markers)
        markers[province].remove();
        delete markers[province];
      }
      setSaved(s);
    }

    function toggleSubreligion(religion){
      var a;
      if(religion=="Buddhists(Tibetan Buddhism)"){a=tibetanOn;}
      if(religion=="Buddhists(Theravada)"){a=theravadaOn;}
      if(religion=="Buddhists(Mahayana)"){a=mahayanaOn;}
      if(religion=="East Asian Religiosity"){a=eastOn;}
      if(religion=="Hindus"){a=hinduOn;}
      if(religion=="Muslims(Sunni)"){a=sunniOn;}
      if(religion=="Muslims(Shia)"){a=shiaOn;}
      if(religion=="Muslims(Non-denominational)"){a=nonOn;}
      if(religion=="Muslims(Ibadi)"){a=ibadiOn;}
      if(religion=="Protestants"){a=protestantsOn;}
      if(religion=="Eastern orthodox"){a=orthodoxOn;}
      if(religion=="Catholics"){a=catholicsOn;}
      if(religion=="Oriental orthodox"){a=orientalOn;}
      if(religion=="Mormons"){a=mormonOn;}
      if(religion=="Ethnic and other religionists"){a=otherOn;}

      if(a){var f2 = f.filter(e => e[2] !== religion);map.current.setFilter("world_religion", f2);setF(f2);}
      else{var b = ["==", "HighRelig"];b.push(religion);var f3 = f.concat([b]);setF(f3);map.current.setFilter("world_religion", f3);}
      
    }

    function toggleReligion(religion){
      if(religion=="Buddhism"){
        if(buddhismOn){
          var f2 = f;
          if(tibetanOn){f2 = f2.filter(e => e[2] !== "Buddhists(Tibetan Buddhism)");setTibetanOn(false);}
          if(theravadaOn){f2=f2.filter(e => e[2] !== "Buddhists(Theravada)");setTheravadaOn(false);}
          if(mahayanaOn){f2 = f2.filter(e => e[2] !== "Buddhists(Mahayana)");setMahayanaOn(false);}
          map.current.setFilter("world_religion", f2);setF(f2);setBuddhismOn(false);
        }
        else{
          var f2 = f;
          if(!tibetanOn){var b = ["==", "HighRelig","Buddhists(Tibetan Buddhism)"];f2 = f2.concat([b]);setTibetanOn(true);}
          if(!theravadaOn){var b = ["==", "HighRelig","Buddhists(Theravada)"];f2 = f2.concat([b]);setTheravadaOn(true);}
          if(!mahayanaOn){var b = ["==", "HighRelig","Buddhists(Mahayana)"];f2 = f2.concat([b]);setMahayanaOn(true);}
          map.current.setFilter("world_religion", f2);setF(f2);setBuddhismOn(true);
        }    
      }
      if(religion=="Islam"){
        if(islamOn){
          var f2 = f;
          if(sunniOn){f2 = f2.filter(e => e[2] !== "Muslims(Sunni)");setSunniOn(false);}
          if(shiaOn){f2=f2.filter(e => e[2] !== "Muslims(Shia)");setShiaOn(false);}
          if(nonOn){f2 = f2.filter(e => e[2] !== "Muslims(Non-denominational)");setNonOn(false);}
          if(ibadiOn){f2 = f2.filter(e => e[2] !== "Muslims(Ibadi)");setIbadiOn(false);}
          map.current.setFilter("world_religion", f2);setF(f2);setIslamOn(false);
        }
        else{
          var f2 = f;
          if(!sunniOn){var b = ["==", "HighRelig","Muslims(Sunni)"];f2 = f2.concat([b]);setSunniOn(true);}
          if(!shiaOn){var b = ["==", "HighRelig","Muslims(Shia)"];f2 = f2.concat([b]);setShiaOn(true);}
          if(!nonOn){var b = ["==", "HighRelig","Muslims(Non-denominational)"];f2 = f2.concat([b]);setNonOn(true);}
          if(!ibadiOn){var b = ["==", "HighRelig","Muslims(Ibadi)"];f2 = f2.concat([b]);setIbadiOn(true);}
          map.current.setFilter("world_religion", f2);setF(f2);setIslamOn(true);
        }    
      }
      if(religion=="Christianity"){
        if(christianityOn){
          var f2 = f;
          if(protestantsOn){f2 = f2.filter(e => e[2] !== "Protestants");setProtestantsOn(false);}
          if(orthodoxOn){f2=f2.filter(e => e[2] !== "Eastern orthodox");setOrthodoxOn(false);}
          if(catholicsOn){f2 = f2.filter(e => e[2] !== "Catholics");setCatholicsOn(false);}
          if(orientalOn){f2 = f2.filter(e => e[2] !== "Oriental orthodox");setOrientalOn(false);}
          if(mormonOn){f2 = f2.filter(e => e[2] !== "Mormons");setMormonOn(false);}
          map.current.setFilter("world_religion", f2);setF(f2);setChristianityOn(false);
        }
        else{
          var f2 = f;
          if(!protestantsOn){var b = ["==", "HighRelig","Protestants"];f2 = f2.concat([b]);setProtestantsOn(true);}
          if(!orthodoxOn){var b = ["==", "HighRelig","Eastern orthodox"];f2 = f2.concat([b]);setOrthodoxOn(true);}
          if(!catholicsOn){var b = ["==", "HighRelig","Catholics"];f2 = f2.concat([b]);setCatholicsOn(true);}
          if(!orientalOn){var b = ["==", "HighRelig","Oriental orthodox"];f2 = f2.concat([b]);setOrientalOn(true);}
          if(!mormonOn){var b = ["==", "HighRelig","Mormons"];f2 = f2.concat([b]);setMormonOn(true);}
          map.current.setFilter("world_religion", f2);setF(f2);setChristianityOn(true);
        }    
      }
    }

    function toggleSide(){
      var mapCanvas = document.getElementsByClassName('mapboxgl-canvas')[0];
      var mapDiv = document.getElementById('map-container');
      if (sideOpen) {
          console.log(sideOpen);
          mapDiv.style.width = '98.34%';
          mapCanvas.style.width = '100%';
          window.setTimeout(()=>map.current.resize(), 10);
      } else {
          console.log(sideOpen);
          mapDiv.style.width = '66.667%';
          mapCanvas.style.width = '100%';
          window.setTimeout(()=>map.current.resize(), 10);
      }
    }

    function resetRfun() {map.current.rotateTo(0)}
    function resetTfun(){map.current.setPitch(0)}
    function barRotate(){var v = document.getElementById('rotationsliderinput').value;map.current.rotateTo(v);}
    function barTilt(){var v = document.getElementById('tiltsliderinput').value;map.current.setPitch(v);}

    const popup = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false
    });

    return (
        <div className="homeMap">
            <div className="homeMapMain">
              {sideMode=="default"&&
                <>
                {sideOpen&&(
                  <Sidebar open={sideOpen} country={country} province={province} firstReligion={firstReligion} numerical={numerical} secondReligion={secondReligion}
                  year={year} dataSource={dataSource} dataURL={dataURL}/>
                 )}
                 {sideOpen &&(<div className='border' onClick={()=>{toggleSide();setSideOpen(!sideOpen);}}><AiFillCaretRight style={{verticalAlign:"bottom"}} size={20}/>Details and Customisations</div>)}
                 {!sideOpen &&(<div className='border' onClick={()=>{toggleSide();setSideOpen(!sideOpen);}}><AiFillCaretLeft style={{verticalAlign:"bottom"}} size={20}/>Details and Customisations</div>)}
                </>
              }
              {sideMode=="save"&&
                  <>
                  <div className="sidebar" style={{width:"33.333%"}}>
                    <button style = {{width:"20%"}} onClick={()=>setSideMode("default")}>back</button>
                    {saved.map(feature=>
                                  <>
                                    <div className="sideBlock"
                                        onMouseLeave={() => {map.current.setFilter("hover-fills", false);}}>
                                      {feature.Country} - {feature.ProvName}<br/>
                                      
                                    
                                    <button onClick = {()=>{
                                      markers[feature.ProvName].remove();
                                      delete markers[feature.ProvName];

                                      var a = religious_data.find(e=>(e.ProvName==feature.ProvName && e.Country==feature.Country));
                                      var s = saved;
                                      var index = s.indexOf(a);
                                      if (index !== -1) {s.splice(index, 1);}
                                      setSaved(s);
                                      }}>
                                      X
                                    </button> 
                                    </div>
                                    <PercentageBar percent1={feature.Numerical} religion1={feature.HighRelig}
                                    percent2={feature.Nummeric_1} religion2={feature.SecRelig}/>
                                    Year: {feature.Year}<br/>
                                    <a href={feature.DataURL}>{feature.DataSource}</a>
                                  </>)}
                    {saved.length==0&&"No Saved Results"}
                    </div>
                  </>
                  }
                <div className = "search">
                  {/* <ReactSearchAutocomplete
                    items={religious_data.filter(e=>subs.includes(e.HighRelig))}
                    onSearch={handleOnSearch}
                    onHover={handleOnHover}
                    onSelect={handleOnSelect}
                    onFocus={handleOnFocus}
                    placeholder="Search"
                    autoFocus
                    formatResult={formatResult}
                    fuseOptions={{ keys: ["Country","Provname"] }}
                    resultStringKeyName="Country"
                    maxResults={100}
                  /> */}
                  <select id = "projection" onChange={()=>{map.current.setProjection(document.getElementById("projection").value);}}
                  style={{marginLeft:"5px"}}>
                      <option value="mercator">Mercator</option>
                      <option value="winkelTripel">Winkel Tripel</option>
                      <option value="naturalEarth">Natural Earth</option>
                  </select>
                </div>
                
                <div ref={mapContainer} style={{width: "66.667%"}} id="map-container" />
                
            </div>
            <div className="religionList">
                <div onMouseOver={()=>setBuddhism_hover(true)} onMouseLeave={()=>setBuddhism_hover(false)}>
                  <div className="religionList_buddhism r" onClick={()=>{toggleReligion("Buddhism");}}
                    style={buddhismOn?{background:"#FEB32A"}:{background:"lightgrey"}}>
                    <div className='sideIcon buddhism'></div>
                  </div>
                  {buddhism_hover && (
                    <div className="buddhism_subs subs">
                      <div onClick={()=>{toggleSubreligion("Buddhists(Tibetan Buddhism)");setTibetanOn(!tibetanOn);}} style={tibetanOn?{background:"transparent linear-gradient(270deg, #FFFFDB 0%, #FDFD9E 40%, #FCFD4A 60%, #CACA2A 99%, #CACA2A 100%) 0% 0%", color:"black"}:{background:"lightgrey"}}>Buddhism[Tibetan]</div>
                      <div onClick={()=>{toggleSubreligion("Buddhists(Theravada)");setTheravadaOn(!theravadaOn);}} style={theravadaOn?{background:"transparent linear-gradient(270deg, #FFF4DC 0%, #FCD77E 40%, #FDB434 60%, #E49A25 100%) 0% 0%", color:"black"}:{background:"lightgrey"}}>Buddhism[Theravada]</div>
                      <div onClick={()=>{toggleSubreligion("Buddhists(Mahayana)");setMahayanaOn(!mahayanaOn);}} style={mahayanaOn?{background:"transparent linear-gradient(270deg, #FDC2B4 0%, #FD7454 40%, #FD3D20 60%, #CA3017 100%) 0% 0%", color:"black"}:{background:"lightgrey"}}>Buddhism[Mahayana]</div>
                    </div>
                  )}
                  
                </div>
                <div onMouseOver={()=>setEast_hover(true)} onMouseLeave={()=>setEast_hover(false)}>
                  <div className="religionList_east r" onClick={()=>{toggleSubreligion("East Asian Religiosity");setEastOn(!eastOn);}} style={eastOn?{background:"#FD331C"}:{background:"lightgrey"}}><div className='sideIcon eastasian'></div></div>
                  {east_hover && (
                    <div className="east_subs subs">
                      <div onClick={()=>{toggleSubreligion("East Asian Religiosity");setEastOn(!eastOn);}} style={eastOn?{background:"transparent linear-gradient(270deg, #FDC2B4 0%, #FD7454 40%, #FD3D20 60%, #CA3017 100%) 0% 0%"}:{background:"lightgrey"}}>East Asian Religiosity</div>
                    </div>
                  )}
                </div>
                <div onMouseOver={()=>setHinduism_hover(true)} onMouseLeave={()=>setHinduism_hover(false)}>
                  <div className="religionList_hinduism r" onClick={()=>{toggleSubreligion("Hindus");setHinduOn(!hinduOn);}} style={hinduOn?{background:"#AC7339"}:{background:"lightgrey"}}><div className='sideIcon hinduism'></div></div>
                  {hinduism_hover && (
                    <div className="hinduism_subs subs">
                      <div onClick={()=>{toggleSubreligion("Hindus");setHinduOn(!hinduOn);}} style={hinduOn?{background:"transparent linear-gradient(270deg, #EBD8C6 0%, #D0A67C 40%, #AA743F 60%, #734E2A 100%) 0% 0%"}:{background:"lightgrey"}}>Hinduism</div>
                    </div>
                  )}
                </div>
                <div onMouseOver={()=>setIslam_hover(true)} onMouseLeave={()=>setIslam_hover(false)}>
                  <div className="religionList_islam r" onClick={()=>{toggleReligion("Islam");}}
                    style={islamOn?{background:"#39AC39"}:{background:"lightgrey"}}>
                      <div className='sideIcon islam'></div>
                  </div>
                  {islam_hover && (
                    <div className="islam_subs subs">
                      <div onClick={()=>{toggleSubreligion("Muslims(Sunni)");setSunniOn(!sunniOn);}} style={sunniOn?{background:"transparent linear-gradient(270deg, #B2E5B3 0%, #7AD07C 40%, #3BAA3F 60%, #216023 100%) 0% 0%"}:{background:"lightgrey"}}>Islam[Sunni]</div>
                      <div onClick={()=>{toggleSubreligion("Muslims(Non-denominational)");setNonOn(!nonOn);}} style={nonOn?{background:"transparent linear-gradient(270deg, #D0DFDF 0%, #85ACAC 40%, #5D8989 60%, #486B6B 100%) 0% 0%"}:{background:"lightgrey"}}>Islam [Non-denominational]</div>
                      <div onClick={()=>{toggleSubreligion("Muslims(Shia)");setShiaOn(!shiaOn);}} style={shiaOn?{background:"transparent linear-gradient(270deg, #E4E4CC 0%, #C1C18B 40%, #A7A75C 60%, #666636 100%) 0% 0%"}:{background:"lightgrey"}}>Islam [Shia]</div>
                      <div onClick={()=>{toggleSubreligion("Muslims(Ibadi)");setIbadiOn(!ibadiOn);}} style={ibadiOn?{background:"transparent linear-gradient(270deg, #CCFDFD 0%, #17E4E4 40%, #0B9797 60%, #034D4C 100%) 0% 0%"}:{background:"lightgrey"}}>Islam [ibadi]</div>
                    </div>
                  )}
                </div>
                <div onMouseOver={()=>setChristianity_hover(true)} onMouseLeave={()=>setChristianity_hover(false)}>
                  <div className="religionList_christianity r" onClick={()=>{toggleReligion("Christianity");}}
                    style={christianityOn?{background:"#4673D2"}:{background:"lightgrey"}}>
                      <div className='sideIcon christianity'></div>
                  </div>
                  {christianity_hover && (
                    <div className="christianity_subs subs">
                      <div onClick={()=>{toggleSubreligion("Catholics");setCatholicsOn(!catholicsOn);}} style={catholicsOn?{background:"transparent linear-gradient(270deg, #D8B2FC 0%, #A54DFB 40%, #7400E1 60%, #40007E 100%) 0% 0%"}:{background:"lightgrey"}}>Catholicism</div>
                      <div onClick={()=>{toggleSubreligion("Protestants");setProtestantsOn(!protestantsOn);}} style={protestantsOn?{background:"transparent linear-gradient(270deg, #C0CFEE 0%, #849FDE 40%, #4872CE 60%, #2F58B5 100%) 0% 0%"}:{background:"lightgrey"}}>Protestantism</div>
                      <div onClick={()=>{toggleSubreligion("Oriental orthodox");setOrientalOn(!orientalOn);}} style={orientalOn?{background:"transparent linear-gradient(270deg, #CBCBFC 0%, #4F4BFA 40%, #0A00C8 60%, #03007E 100%) 0% 0%"}:{background:"lightgrey"}}>Oriental Orthodoxy</div>
                      <div onClick={()=>{toggleSubreligion("Eastern orthodox");setOrthodoxOn(!orthodoxOn);}} style={orthodoxOn?{background:"transparent linear-gradient(270deg, #C0CFEE 0%, #A1A1C1 40%, #7373A2 60%, #50507B 100%) 0% 0%"}:{background:"lightgrey"}}>Eastern Orthodoxy</div>
                      <div onClick={()=>{toggleSubreligion("Mormons");setMormonOn(!mormonOn);}} style={mormonOn?{background:"transparent linear-gradient(270deg, #E5E5E5 0%, #BEBEBE 40%, #989898 60%, #737373 100%) 0% 0%"}:{background:"lightgrey"}}>Mormon</div>
                    </div>
                  )}
                </div>
                <div onMouseOver={()=>setOther_hover(true)} onMouseLeave={()=>setOther_hover(false)}>
                  <div className="religionList_other r" onClick={()=>{toggleSubreligion("Ethnic and other religionists");setOtherOn(!otherOn);}} style={otherOn?{background:"#FD1FC6"}:{background:"lightgrey"}}><div className='sideIcon other'></div></div>
                  {other_hover && (
                    <div className="other_subs subs">
                      <div onClick={()=>{toggleSubreligion("Ethnic and other religionists");setOtherOn(!otherOn);}} style={otherOn?{background:"transparent linear-gradient(270deg, #FFCCF0 0%, #FD81DD 40%, #FD28C4 60%, #CA1397 100%) 0% 0%"}:{background:"lightgrey"}}>Ethnic and Other Religions</div>
                    </div>
                  )}
                </div>
            </div>
            <Link to="/Buddhism"><div className="bottomBar"><AiFillCaretUp style={{verticalAlign:"bottom"}} size={20}/>Explore different religious worlds by clicking on the symbols</div></Link>
        </div>
    );
};

export default HomeMap;

// "browserslist": [
//   "defaults",
//   "not ie 11"
//   ]